import Vue from 'vue'
import App from './App.vue'
import Toast from '@common/components/vue/dida/toast/index.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { point } from '@/utils/point'
import { getAppClient } from '@/utils/environment.util'
import { getQueryString } from '@common/libs/util.url.js'
import Env from '@common/libs/util.env.js'
import { addStat2 } from '@/utils/stat.util'
import * as Sentry from 'dida-sentry-vue-sdk'
import { BrowserTracing } from '@sentry/tracing'
import packageInfo from '../package.json'
const app_lient = getAppClient()

// 只有www.didapinche.com绑定了微信移动应用开发
// a-m.didachuxing.com 和 www.didachuxing.com 没有绑定 不能使用微信开放标签
// if (window.location.host === 'web.didachuxing.com') {
//   window.location.replace(window.location.href.replace(window.location.host, 'www.didapinche.com'))
// }

Vue.use(Toast)

Vue.use(VueAwesomeSwiper)
// 忽略自定义元素标签抛出的报错
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
  'wx-open-launch-app'
]
if (getAppClient(true) !== 'my') { // 支付宝环境不进行埋点请求
  point()
}

Vue.config.productionTip = false
const mixin = {
  methods: {
    goto (path, isReplace) {
      if (!isReplace) {
        this.$router.replace(path)
      } else {
        this.$router.push(path)
      }
    }
  }
}
Vue.mixin(mixin)

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    release: packageInfo.name + '@' + packageInfo.version,
    environment: Env.isEnvOnline ? 'online' : (Env.isEnvECS ? 'simu' : 'test'),
    dsn: 'https://3f7d4ed2394f444cbd49f7207a7508cc@sentry.didapinche.com/42',
    integrations: [
      new BrowserTracing({
        tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  })
}

new Vue({
  data () {
    return {
      newly: 1, // 是否是新用户0是1不是
      envir: ''
    }
  },
  async created() {
    this.envir = await getEnvir()
    setTimeout(() => {
      addStat2('领券模板_进入页面', CID, getQueryString('goodCid'), this.envir) // 添加埋点
    }, 500)
  },
  render: h => h(App)
}).$mount('#app')

var goodCid = '|goodCid:' + getQueryString('goodCid')
var url = getQueryString('referer_url') ? '|url:' + getQueryString('referer_url') : ''
var IP = getQueryString('IP') ? '|IP:' + getQueryString('IP') : ''
var channel = getQueryString('channel') ? '|channel:' + getQueryString('channel') : ''
var title = getQueryString('title') ? '|title:' + getQueryString('title') : ''
var ad = getQueryString('ad') ? '|ad:' + getQueryString('ad') : ''
var name = goodCid + url + IP + channel + title + ad
var CID = getQueryString('cid') || getQueryString('user_cid') || getQueryString('userCid') || getQueryString(
  'encrypted_cid') || localStorage.getItem('cid') || ''

function addStatScript(type, name, cid, callback) {
  var didaStatScript = document.createElement('script')
  didaStatScript.src = 'https://venus.didachuxing.com/static/stat/stat.min.js?banHash=true&type=' + type +
    '&name=' + name + '&app_user_cid=' + cid
  didaStatScript.id = 'didaStat'
  didaStatScript.onload = function () {
    typeof callback === 'function' && callback()
  }
  document.body.appendChild(didaStatScript)
}
addStatScript('h5', '领券模板' + name, CID, function () {})

async function getEnvir() {
  if (Env.inApplication) {
    // app内
    return 'app'
  } else if (Env.inWechat || getAppClient(true)) {
    return await new Promise((resolve, reject) => {
      app_lient.getEnv((res) => {
        let result = ''
        if (res.miniprogram) {
          result = Env.inWechat ? 'minipg' : 'miniali'
        } else {
          result = Env.inWechat ? 'wxh5' : 'alih5'
        }
        return resolve(result)
      })
    })
  } else {
    return 'h5'
  }
}

